<!--
 * @Author: JakeChiu
 * @Emaiil: 3289011@qq.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2022-01-20 16:30:27
 * @LastEditTime: 2022-11-16 17:18:02
 * @LastEditors: JakeChiu
 * @Description: JakeChiu in HX at Do not edit
 * @FilePath: \visualh5\src\components\payment.vue
-->
<template>
  <div id="app">
    <div class="header"><div class="back" @click="goback"></div><div class="back2" @click="goback"></div>订单页面</div>
    <div class="content">
        <img src="https://imgcd.homeway.com.cn/images/loading.gif" class="img">
        <div :class="['war',paying?'paying':'']">{{cont}}</div>
    </div>
  </div>
</template>

<script>
import {MessageBox } from "mint-ui";
export default {
  name: "paymentapp",
  /**
   * @description: 本地存储
   * @param {*}
   * @return {*}
   */
  data() {
    return {
      id: 0,
      invoketoken: 0,
      modeid: 0,
      modeitem: null,
      cont:'',
      paying:true,
      getstatuenum:0
    };
  },
  watch: {},
  components: {},
  // 创建完毕
  created() {
    const _this = this;
    let invoketoken = _this.getUrlParam("invoketoken");
    _this.id = invoketoken.split("token_")[0].split("id_")[1];
    _this.invoketoken = invoketoken.split("token_")[1];
    _this.modeid = invoketoken.split("id_")[0].replace("_", "+").split("+")[1];
    // 获取登录信息
    _this.getData(_this.apilist("isLogin"), function (re) {
      _this.islogin = re.islogin == "True" ? true : false;
      _this.userinfo = re;
    });
    // 获取模版信息
    _this.getData(
      _this.apilist("getmarketpagebyid"),
      function (res) {
        if (res.resultKey === "ok") {
          // 获取运营后台模版队列
          _this.setmode(res.data.pageContent);
        } else {
          MessageBox({
            title: "提示",
            message: "获取回调地址错误",
            showCancelButton: false,
          });
        }
      },
      {
        id: _this.id,
      }
    );
  },
  methods: {
    /**
     * @description: 回跳地址
     * @return {*}
     */    
    goback(){
        const _this = this;
        location.href = `https://${_this.isTest()?'test':''}caidaoad.homeway.com.cn/${_this.id}.html`;
    },
    /**
     * @description: 支付成功
     * @return {*}
     */ 
    paysuc(){
        const _this = this;
        _this.paying=false;
        _this.cont = '支付成功，正在跳转...'
        location.href = _this.modeitem.fastpaybackurl
    },   
        /**
     * @description: 支付失败
     * @return {*}
     */ 
    payerr(){
        const _this = this;
        _this.paying=false;
        _this.cont = '支付失败，正在跳转...'
        location.href = _this.modeitem.fastpayerrbackurl

    }, 
    /**
     * @description: 根据订单号获取订单信息
     * @return {*}
     */    
    getorderbyuserorderid(id){
        const _this = this;
              _this.getData(
        _this.apilist("fastgetpaystatus"),
        function (res) {
          if (res.respCode == "0") {
            if(res.result=='1'){
                _this.paysuc()
          } else {
            // 失败
                setTimeout(function(){
                    _this.getstatuenum=_this.getstatuenum+1;
                    if(_this.getstatuenum>2){
                        _this.payerr();
                    }else{
                        _this.getorderbyuserorderid(id)
                    }
                },2000)
                
          }
          }else{
            _this.paying=false;
            _this.cont = res.errorMgs
          }
        },
        {
          orderid: id,
        }
      );
    },
    /**
     * @description: token获取订单信息
     * @return {*}
     */
    getorderinfo() {
      const _this = this;
      _this.getData(
        _this.apilist("fastpaygetinvoketoken"),
        function (res) {
          if (res.respCode == "0") {
            // result 支付状态（0：未扫码，1：支付中，订单号：支付完成）
            if(res.result=='0'){
                _this.payerr()
            }else if(res.result=='1'){
                _this.payerr()
            }else{
                if(res.result.length>4){
                    _this.getorderbyuserorderid(res.result);
                }
            }
            
          } else {
            // 失败
             _this.paying=false;
            _this.cont = res.errorMgs
          }
        },
        {
          invoketoken: _this.invoketoken,
        }
      );
    },
    /**
     * @description: 发送验证码后倒计时
     * @return {*}
     */
    countdown() {
      const _this = this;
      _this.cdnum = 60;
      window.cdnumtimer = setInterval(() => {
        _this.cdnum = _this.cdnum - 1;
        if (_this.cdnum == 0) {
          window.clearInterval(window.cdnumtimer);
        }
      }, 1000);
    },
    /**
     * @description: 根据id获取数据
     * @param {*} id
     * @return {*}
     */
    getItem(id) {
      const _this = this;
      let item = "";
      for (let items of _this.modelist) {
        if (items.id === id) {
          item = items;
          break;
        }
      }
      return item;
    },
    /**
     * @description: 读取接口处理数据存储到本地
     * @param {*} _data
     * @return {*}
     */
    setmode(_data) {
      const _this = this;
      let arr = JSON.parse(JSON.parse(_data));
      _this.modelist = arr.modelist;
      _this.modeitem = _this.getItem(_this.modeid);
      _this.getorderinfo();
      
    },
  },
};
</script>

<style lang="scss">
#app,
.main {
  width: 100%;
  height: 100%;
}
#app{
    display:flex;
    flex-direction: column;
}
.header{
    text-align: center;
    height:50px;
    line-height: 50px;
    color: #000;
    font-size:16px;
    position: relative;
    border-bottom: 1px #ddd solid;
    display: none;
    .back{
        background:url(../assets/images/back.png) no-repeat center/100% auto;
        height:100%;
        position:absolute;
        left:15px;top:0;
        width:12px;
    }
    .back2{
        background:url(../assets/images/back2.png) no-repeat center/100% auto;
        height:100%;
        position:absolute;
        left:60px;top:0;
        width:15px;
    }
}
.content{
    flex:1;
    display:flex;
    align-items: center;
    text-align:center;
    justify-content:center;
    flex-direction: column;
    img{
        width: 33%;
    }
    .war{
        text-align: center;
        color:#000;
        font-size:14px
    }
}
.paying::after{
    content:'支付中，请稍候';
    animation: cont 3s linear 0s infinite normal;
    width:110px;
    text-align: left;
    display: block;
}
@keyframes cont
{
    25%  {
        content:'支付中，请稍候.'
    }
    50%  {
        content:'支付中，请稍候..'
    }
    100% {
        content:'支付中，请稍候...'
    }
}
</style>
